import styled from "styled-components";

export const BolsaManualContainer = styled.div`
  height: 100%;
  overflow-y: hidden;
  .btn-preencher-pos2019 {
        margin-bottom: 3rem;
    }
`;
